import React, { useState, useEffect, lazy, Suspense } from 'react';
import SharedHelmet from ".././Helmet";
import { FirstAds, SecondAds } from "../../Ads";
const BlinkingText = lazy(() => import('../../BlinkingText'));
const RelatedLinks = lazy(() => import('../RelatedLinks'));
const MainCalculatorsList = lazy(() => import('./MainCalculators'));
const TITLE = "Berapa Hari Lagi Piala Asia 2027 - Hitung Mundur Piala Asia";
const DESCRIPTION = "Berapa hari lagi Piala Asia 2027? Hitung mundur Piala Asia memungkinkan Anda mengetahui waktu yang tersisa hingga dimulainya turnamen olahraga terbesar di benua Asia. Ikuti hitung mundur dan tetap terinformasi mengenai tanggal pasti dimulainya Piala Asia.";
const KEYWORDS = "Piala Asia 2027, berapa hari lagi Piala Asia, hitung mundur Piala Asia, kapan Piala Asia, AFC Asian Cup, hitung mundur Piala Asia, jadwal Piala Asia, pertandingan Piala Asia";
const OG_URL = "https://do-calculate.com/articles-id/asian-cup";
function AFCAsianCupCountdown() {
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const asianCupDate = new Date("2027-01-12T00:00:00");
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(asianCupDate));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(asianCupDate));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>Berapa Hari Lagi Piala Asia 2027</h1>
            <Suspense fallback={<div>Loading...</div>}>
                <BlinkingText text="Berapa hari lagi Piala Asia: Diperkirakan turnamen dimulai hari Selasa 12 Januari 2027 di Qatar." />
            </Suspense>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px', textAlign: 'center' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <thead>
                            <tr>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Menit</th>
                                <th>Detik</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{timeLeft.days}</td>
                                <td>{timeLeft.hours}</td>
                                <td>{timeLeft.minutes}</td>
                                <td>{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Informasi tentang Piala Asia 2027</h3>
                    <p>
                        Piala Asia adalah turnamen olahraga terpenting di benua Asia untuk sepak bola, di mana tim nasional dari banyak negara Asia bersaing untuk merebut gelar juara. Piala Asia 2027 akan digelar di Qatar, dan edisi ini istimewa karena merupakan kali kedua Qatar menjadi tuan rumah setelah tahun 2011.
                    </p>
                    <p>
                        Diperkirakan turnamen ini akan diikuti oleh 24 tim nasional dari berbagai penjuru Asia, dan kompetisinya akan lebih seru dari sebelumnya.
                    </p>
                    <hr />
                    <Suspense fallback={<div>Loading...</div>}>
                        <RelatedLinks />
                    </Suspense>
                </div>
                <div className="col">
                    <Suspense fallback={<div>Loading...</div>}>
                        <MainCalculatorsList />
                    </Suspense>
                </div>
            </div>
        </div>
    );
}
export default AFCAsianCupCountdown;
